export default __webpack_public_path__ + "static/media/fofIcon.5d465993.svg";